import React, { useState } from 'react';
import {
  LocalHotel
} from "@mui/icons-material";
import {
  Tooltip, 
} from "@mui/material";

import { 
  Character, 
  CharacterSheetInterface,
} from "@dndModels";

import CharacterRest from "@dndComponents/character/misc/CharacterRest";
import ModalOrDrawer from "@components/display/ModalOrDrawer";

interface Props {
  character: Character;
  char_interface: CharacterSheetInterface;
}

export default function CharacterRestButton({
  character,
  char_interface: obj,
}: Props) {
  const [open, setOpen] = useState(false);

  const renderExtras = () => {
    return (
      <ModalOrDrawer
        open={ open } 
        onClose={() => {
          setOpen(false);
          character.subscription_holder.modalClosed();
        }}>
        { open ?
          <CharacterRest 
            char={character}
            char_interface={obj}
            // onChange={onChange}
          />
          : <></>
        }
      </ModalOrDrawer>
    );
  }

  return (
    <>
      <Tooltip title="Take a Rest">
        <LocalHotel
          className="clickable"
          onClick={() => {
            setOpen(true);
          }}
        />
      </Tooltip>
      { renderExtras() }
    </>
  ); 
}

